// Opening an event, market or asset page from a list, card or table happens in a
// new tab, so the list the user came from stays where it is. The header quick
// search is the one place that keeps navigating in the same tab.
//
// One exception: an iPhone or iPad web app added to the Home Screen. Its storage
// is separate from Safari's, and a tab opened from it lands in Safari, signed
// out. There the page opens in place, as it did before. navigator.standalone is
// defined only by iOS Safari, so every other environment keeps the new tab.

export const inHomeScreenApp = (): boolean =>
    typeof navigator !== 'undefined' &&
    (navigator as Navigator & { standalone?: boolean }).standalone === true;

// Spread onto an <a>, a react-router <Link> or a MUI element rendered as one:
// <Link to={path} {...NEW_TAB_LINK_PROPS}>. react-router does not intercept a
// link whose target is _blank, so the browser opens it natively.
export const NEW_TAB_LINK_PROPS: { target?: '_blank'; rel?: string } =
    inHomeScreenApp() ? {} : { target: '_blank', rel: 'noopener noreferrer' };

// For click handlers that used to call navigate(path).
export function openInNewTab(path: string): void {
    if (inHomeScreenApp()) {
        window.location.assign(path);
        return;
    }
    window.open(path, '_blank', 'noopener,noreferrer');
}
